import AccessIssue from '../schema/AccessIssue';
import { AttachmentConstants } from 'owa-attachment-file-types/lib/utils/attachmentConstants';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import getConditionalAccessIssue from './getConditionalAccessIssue';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function getAccessIssues(): AccessIssue[] {
    const userConfiguration: OwaUserConfiguration = getUserConfiguration();
    return getConditionalAccessIssue(userConfiguration);
}

export function getAccessIssuesForAttachments(attachments: AttachmentType[]): AccessIssue[] {
    const userConfiguration: OwaUserConfiguration = getUserConfiguration();
    return attachments && attachments.length > 0 && hasNonInlineAttachment(attachments)
        ? getConditionalAccessIssue(userConfiguration)
        : [];
}

function hasNonInlineAttachment(attachments: AttachmentType[]) {
    return attachments.some(a => !isInline(a));
}

function isInline(attachment: AttachmentType): boolean {
    return attachment.IsInline && !isCloudyAttachment(attachment);
}

function isCloudyAttachment(attachment: AttachmentType): boolean {
    return attachment.__type === AttachmentConstants.attachmentTypes.REFERENCE_ATTACHMENT_TYPE;
}
